export default {
  classic: 'bordered centered striped',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/tables.js